import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EmptyOptionType } from 'src/components/atomic/Molecules/EmptyComponent'
import { SvcLocationType } from 'src/types/websocket'

export type LocationPageStateType = {
  EmptyComponentStatus: EmptyOptionType
  soundPlayStatus: boolean
  selectPin: SvcLocationType | null
  soundListFlag: boolean
  imageDetailFlag: boolean
  markerIndex: number | null
  selectImage: 'F' | 'B'
  mapCenterPosition: { lat: number; lng: number }
}

const initialState: LocationPageStateType = {
  EmptyComponentStatus: 'default',
  soundPlayStatus: false,
  selectPin: null,
  soundListFlag: false,
  imageDetailFlag: false,
  markerIndex: null,
  selectImage: 'F',
  mapCenterPosition: { lat: 0, lng: 0 },
}

const LocationPageSlice = createSlice({
  name: 'LocationPage',
  initialState,
  reducers: {
    setEmptyComponentStatus(state, action: PayloadAction<EmptyOptionType>) {
      state.EmptyComponentStatus = action.payload
    },

    setSoundPlayStatus(state, action) {
      state.soundPlayStatus = action.payload
    },
    setSelectPin(state, action) {
      state.selectPin = action.payload
    },
    resetSelectPin(state) {
      state.selectPin = null
    },
    setSoundListFlag(state, action) {
      state.soundListFlag = action.payload
    },
    setImageDetailFlag(state, action) {
      state.imageDetailFlag = action.payload
    },
    setMarkerIndex(state, action) {
      state.markerIndex = action.payload
    },
    setSelectImage(state, action) {
      state.selectImage = action.payload
    },
    setMapCenterPosition(state, action) {
      state.mapCenterPosition = action.payload
    },
  },
})

export const {
  setSoundPlayStatus,
  setSelectPin,
  setSoundListFlag,
  resetSelectPin,
  setImageDetailFlag,
  setMarkerIndex,
  setSelectImage,
  setEmptyComponentStatus,
  setMapCenterPosition,
} = LocationPageSlice.actions

export default LocationPageSlice.reducer
